/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-23 14:03:22
 *
 * LastModified: 2017-05-23 14:03:22
 *-------------------------------------------------------*/
import localForage from 'localforage'

import Auth from '../../../utils/Auth'

const defaultState = {
  brands: [],
  locales: [],
  products: [],
  store: {}
}

function authUser(state = defaultState, action) {
  switch (action.type) {
    case 'SET_AUTH':
      return Object.assign({}, state, action.payload)
    case 'LOGIN_SUCCESS': {
      const data = {
        token: action.payload.id,
        userId: action.payload.userId,
        s3Url: action.payload.config.url,
        ttl: action.payload.ttl,
        created: action.payload.created
      }
      Auth.setAuth(data)
      return Object.assign({}, state, action.payload.account)
    }
    case 'LOGIN_FAILED':
      return {
        ...state,
        error: action.payload
      }
    case 'REMOVE_AUTH':
      Auth.removeAuth()
      localForage.clear()
      return defaultState
    case 'EDIT_PROFILE_SUCCESS':
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export default authUser



// WEBPACK FOOTER //
// ./routes/auth/reducer/index.js